import React from 'react';


const LoadingScreen = ({text}) => (
  <div className="loading-screen">
    <div className="loading-animation"></div>
    <p className="loading-title">{text}</p>
  </div>
);

export default LoadingScreen;
